<template>
    <div v-loading="loading" class="py-4 mt-6 container-fluid page-shell">
        <div class="row g-3">
            <div class="col-sm-8">
                <div class="card soft-card soft-table-card">
                    <div class="soft-card-header">
                        <h6>{{ $t("filesTitle") }}</h6>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <el-table size="small" border class="el-table-css" :data="this.dataTable" style="width: 100%;">
                                <el-table-column width="40">
                                    <template #default="scope">
                                        <div class="text-center">
                                            <i v-if="delVis(scope.row.commandUserId)"
                                                class="text-lg bi bi-download"></i>
                                            <i v-if="!delVis(scope.row.commandUserId)" class="text-lg bi bi-upload"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('commonDate')" prop="createdDateStr" width="120">
                                </el-table-column>
                                <el-table-column :label="$t('commonFileName')">
                                    <template #default="scope">
                                        <div class="d-flex align-items-center gap-2">
                                            <img class="file-ext-icon"
                                                :src="scope.row.ext === '.xlsx' ? require('@/assets/img/icons/microsoft-files/.xlsx.png') :
                                                    scope.row.ext === '.docx' ? require('@/assets/img/icons/microsoft-files/.docx.png') :
                                                        scope.row.ext === '.pdf' ? require('@/assets/img/icons/microsoft-files/.pdf.png') : require('@/assets/img/icons/microsoft-files/photo.png')"
                                                alt="file-icon">
                                            <a class="table-link" @click="download(scope.row.title)">
                                                {{ scope.row.title }}
                                            </a>
                                        </div>

                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" width="100">
                                    <template #default="scope"> 
                                        <el-button v-if="delVis(scope.row.commandUserId)" class="el-button-edit" type="danger"
                                            :icon="Delete" text
                                            @click="deleteFile(scope.row)" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="card soft-card files-upload-card">
                    <div class="card-body">
                        <el-upload class="upload-demo" drag :action="fileurl" multiple>
                            <i class="fa fa-upload files-upload-icon"></i>
                            <div class="el-upload__text">
                                Drop file here or <em>click to upload</em>
                            </div>
                        </el-upload>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="alert" class="app-toast-host">
            <soft-alert :color="alertColor" dismissible @dismiss="closeSnackbar">
                {{ alertColor == 'success' ? $t('operationSuccess') : $t('operationFailed') + errorId }}
            </soft-alert>
        </div>
    </div>
</template>

<script>
import { getPolicyId } from "@/project/Source/routes";

import "bootstrap-icons/font/bootstrap-icons.css";
import { UploadFilled } from '@element-plus/icons-vue'
import { Download, Delete } from "@element-plus/icons-vue";
import { fileurl, swalDialogClass } from "@/project/Source/helper.js";
import Source from "@/project/Source/claim.js";
import JSZip from "jszip";
import CryptoJS from "crypto-js";
import SoftAlert from "@/components/SoftAlert.vue";
import JSZipUtils from "jszip-utils";
import saveAs from "save-as";
import * as XLSX from "xlsx";

export default {
    components: { SoftAlert },
    data() {
        return {
            UploadFilled,
            Delete,
            tableData: [],
            alert: false,
            dataTable: null,
            Download,
            alertColor: null,
            fileurl
        }
    },
    mounted() {
        this.getFiles();
        this.onGlobalRefresh = () => {
            this.getFiles();
        };
        window.addEventListener("app:refresh-data", this.onGlobalRefresh);
    },
    beforeUnmount() {
        if (this.onGlobalRefresh) {
            window.removeEventListener("app:refresh-data", this.onGlobalRefresh);
        }
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            const reader = new FileReader();
            reader.onload = (e) => {
                const binaryStr = e.target.result;
                const workbook = XLSX.read(binaryStr, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                this.tableData = data;
                console.log(data)
            };
            reader.readAsBinaryString(file);
        },
        download(name) {
            return new Promise((resolve, reject) => {
                const urls = [`${fileurl}${name}`];
                const zip = new JSZip();
                const zipFilename = "cm.zip";
                let count = 0;

                urls.forEach((url) => {
                    JSZipUtils.getBinaryContent(url, (err, data) => {
                        if (err) {
                            reject(err);
                            return;
                        }

                        zip.file(`${name}`, data, { binary: true });
                        count++;

                        if (count === urls.length) {
                            zip.generateAsync({ type: "blob" }).then((content) => {
                                saveAs(content, zipFilename);
                                resolve(true);
                            });
                        }
                    });
                });
            });
        },
        delVis(id) {
            return JSON.parse(CryptoJS.AES.decrypt(window.localStorage.getItem("user"),
                "secret_key"
            ).toString(CryptoJS.enc.Utf8)
            ).userId == id
        },
        getFiles() {
            const data = {
                "id": getPolicyId(this.$route),
                "requestCorrelationId": "string",
                "insuredTypeId": 14,
                "sourceType": "m"
            }

            Source.Files(data).then((response) => {
                this.dataTable = response.data.data
            })
        },
        async deleteFile(row) {
            this.$swal({
                title: this.$t("commonAreYouSure"),
                text: this.$t("confirmDeleteFile"),
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: this.$t("commonCancel"),
                confirmButtonText: this.$t("commonConfirm"),
                customClass: swalDialogClass(),
                buttonsStyling: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const deleteData = {
                        "requestCorrelationId": Date.now().toString(36) + Math.random().toString(36).substr(2),
                        "data": {
                            "id": row.id
                        }
                    }
                    Source.DropFilesRequest(deleteData)
                        .then((response) => {
                            if (response.data.isSuccess == undefined) {
                                this.alertColor = 'danger'
                                this.errorId = deleteData.requestCorrelationId
                            } else {
                                this.getFiles()
                                this.alertColor = 'success'
                            }
                            this.Notif();
                        })

                } else if (result.dismiss === this.$swal.DismissReason.cancel) {
                    this.$swal.dismiss;
                }
            });
        },
        closeSnackbar() {
            this.alert = false;
        },
        Notif() {
            this.alert = true;
            setTimeout(this.closeSnackbar, 5000);
        },
    }
}
</script>
<style scoped>
.file-ext-icon {
  width: 30px;
  height: auto;
}

.files-upload-card {
  height: 100%;
}

.files-upload-icon {
  font-size: 1.5rem;
  color: var(--bs-success);
  margin-bottom: 0.5rem;
}

:deep(.el-upload) {
  --el-upload-dragger-padding-horizontal: 60px;
  --el-upload-dragger-padding-vertical: 10px;
  width: 100%;
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  outline: none;
}

:deep(.el-upload-dragger) {
  width: 100%;
}
</style>
